import React from 'react';
import PropTypes from 'prop-types';
import { Pagination as AntPagination } from 'antd';

const Pagination = ({
  callback,
  page,
  setPage,
  count,
  q,
  pageSize,
}) => (
  <div style={{ margin: '16px 0' }}>
    <AntPagination
      onChange={(pag) => {
        setPage(pag);
        callback(pag, q);
      }}
      total={count}
      current={page}
      pageSize={pageSize}
      showSizeChanger={false}
      showQuickJumper={false}
    />
  </div>
);

Pagination.propTypes = {
  count: PropTypes.number,
  callback: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  q: PropTypes.shape({}).isRequired,
  // El tamaño de página real que usa quien consulta el servidor (`paginationCallback`
  // pide esta cantidad de filas por página) -- antd asume 10 si no se le indica, lo
  // que desalinea el total de páginas mostrado contra lo que de verdad trae cada
  // página cuando el consumidor usa un page_size distinto (ver BitacoraAuditoria.jsx).
  pageSize: PropTypes.number,
};

Pagination.defaultProps = {
  count: 0,
  pageSize: 10,
};

export default Pagination;
